import { Link } from "react-router-dom";

export default function ServiceCard({ service }) {
  const name = service.serviceName || "—";
  return (
    <Link to={`/services/${encodeURIComponent(name)}`} style={{ textDecoration: "none", color: "inherit" }}>
      <div className="card">
        <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.1rem" }}>{name}</h2>
        <div style={{ fontSize: "0.85rem", color: "#71767b" }}>
          Last deploy: {service.lastDeployedAt || "—"}
        </div>
        <div style={{ marginTop: "0.5rem", fontSize: "0.85rem", color: "#71767b" }}>
          Last revision: {(service.lastRevision || "—").slice(0, 12)}
        </div>
        <div style={{ marginTop: "0.35rem", fontSize: "0.85rem" }}>
          Environment: {service.lastEnvironment || "—"}
        </div>
      </div>
    </Link>
  );
}
